import { render, staticRenderFns } from "./listUserPage.vue?vue&type=template&id=55cf81d7&scoped=true&"
import script from "./listUserPage.vue?vue&type=script&lang=js&"
export * from "./listUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf81d7",
  null
  
)

export default component.exports